import { useDispatch, useSelector } from "react-redux";
import Footer from "../../components/Footer";
import SubHeader from "../../components/SubHeader";
import { RootState } from "../../store/store";
import { useEffect, useState } from "react";
import LocalStorageService from "../../services/localStorageService";
import SimpleScenario from "../../data/SimpleScenario";
import { IScenario } from "../../types/IScenario";
import { setEditorMode, setScenarios, setSelectedScenario } from "../../store/editorSlice";
import { EditorMode } from "../../types/editorModeEnum";
import { useNavigate } from "react-router-dom";
import RoleString from "../../components/RoleString";
import ConfirmPopup from "../../components/ConfirmPopup";

function ScenarioList() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { scenarios, selectedScenario } = useSelector((state: RootState) => state.editor);
    const [ viewSelectedScenario, setViewSelectedScenario ] = useState('');
    const [ confirmPopupIndex, setConfirmPopupIndex] = useState(-1);

    useEffect(() => {        
        let loadedScenarios = LocalStorageService.GetScenarios();
        if(loadedScenarios.length === 0){
            loadedScenarios = [
                SimpleScenario as IScenario
            ]
        }
        if(selectedScenario) {
            setViewSelectedScenario(selectedScenario);
        } else {
            dispatch(setSelectedScenario(loadedScenarios[0].guid));
            setViewSelectedScenario(loadedScenarios[0].guid);
        }
        dispatch(setScenarios(loadedScenarios));
    }, []);

    const onRemove = (index: number) => {
        const clone = [
            ...scenarios,
        ]
        clone.splice(index,1);
        dispatch(setScenarios(clone));
        setViewSelectedScenario('');
        LocalStorageService.SaveScenarios(clone);
    }

    const onViewSelect = (guid: string) => {
        setViewSelectedScenario(guid);
    }

    const getScenarioList = () => {
        return <div className="mafia-scenario-list">
            {scenarios.map((scenario, index) => {
                const isSelected = scenario.guid === viewSelectedScenario;
                return <div className={`mafia-scenario-row ${isSelected ? 'reverted' : ''}`} key={index} onClick={() => onViewSelect(scenario.guid)}>
                    <div className="pos">{index + 1}</div>
                    <div className="name">{scenario.name} </div>
                    <div className="summary"><RoleString raw_scenario={scenario.raw_scenario} short/></div>
                    <div className="button">
                        <button onClick={()=>onEdit(scenario.guid)}>Edit</button>    
                        <button onClick={()=>setConfirmPopupIndex(index)} value={index}>Remove</button>
                    </div>

                </div>
            })}
        </div>
    }

    const onCreate = () => {
        dispatch(setSelectedScenario(('')));
        dispatch(setEditorMode(EditorMode.Create));
    }

    const onEdit = (guid: string) => {
        dispatch(setSelectedScenario(guid));
        dispatch(setEditorMode(EditorMode.Edit));
    }

    const onSelect = (guid: string) => {
        dispatch(setSelectedScenario(guid));
        navigate('/game');
    }

    if (confirmPopupIndex > -1) {
        return <div className="mafia-container-wrapper">
            <div className="mafia-container">
                <ConfirmPopup message="Are you sure?"
                    onConfirm={() => {
                        onRemove(confirmPopupIndex);
                        setConfirmPopupIndex(-1)
                    }}
                    onCancel={() => setConfirmPopupIndex(-1)} />
            </div>
        </div>
    }

    return <div className="mafia-container-wrapper">
        <div className="mafia-container">
            <SubHeader>Scenario List</SubHeader>
            <div className="mafia-scenario-container mafia-list-container">
                {getScenarioList()}
            </div>
        </div>
        <Footer>
            <button onClick={onCreate}>Create New</button>        
            <button onClick={() => onSelect(viewSelectedScenario)} className={viewSelectedScenario ? '' : 'disabled'}>Select</button>
        </Footer>
    </div>

}

export default ScenarioList;